module.exports = __webpack_public_path__ + "static/media/slide2.56b73c70.png";